import(/* webpackMode: "eager" */ "/vercel/path0/app/(founder)/(home)/_components/get-started-btn.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(founder)/(home)/_components/hyper-report-btn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Technology"] */ "/vercel/path0/app/(founder)/(home)/_components/sections/technology.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/icons/report-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/images/home/astronaut-dancing.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/images/home/astronaut-with-computer.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/images/home/astronaut.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/images/home/rocket.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
